import { useAgencyCampaignContext } from '../../../agencyCampaignContext';
import { AgencyCampaignSection, AgencyEditorMode } from '../../../../agency/model';
import { DashboardTableRowActionItem, DashboardTableRowActions } from '@shigo-ui/dashboard-ui';
import { Link } from '@tanstack/react-router';
import { Copy, Layers, Pencil } from 'lucide-react';

import { dashboardT } from '../../../../../lib/messages';

export function LineItemActions({
  campaignId,
  lineItemId,
  name,
  pending,
  onDuplicate,
}: {
  campaignId: string;
  lineItemId: string;
  name: string;
  pending: boolean;
  onDuplicate: (deepCopyCreatives: boolean) => void;
}) {
  const scope = useAgencyCampaignContext();
  return (
    <DashboardTableRowActions
      label={dashboardT('lineItems.actionsFor', { name })}
      pending={pending}
      triggerClassName="h-8 w-8"
    >
      <DashboardTableRowActionItem asChild>
        <Link
          to={
            scope
              ? '/a/$agencyId/campaigns/$section'
              : '/campaigns/campaigns/overview/$campaignId/line-items/edit/$lineItemId'
          }
          params={{
            campaignId,
            lineItemId,
            agencyId: scope?.agency.id ?? '',
            section: AgencyCampaignSection.LineItems,
          }}
          search={
            scope ? { editor: AgencyEditorMode.Edit, id: lineItemId, campaign: campaignId } : {}
          }
        >
          <Pencil className="h-4 w-4" aria-hidden="true" />
          {dashboardT('campaigns.edit')}
        </Link>
      </DashboardTableRowActionItem>
      <DashboardTableRowActionItem
        onClick={() => {
          onDuplicate(false);
        }}
      >
        <Copy className="h-4 w-4" aria-hidden="true" />
        {dashboardT('campaigns.duplicate')}
      </DashboardTableRowActionItem>
      <DashboardTableRowActionItem
        onClick={() => {
          onDuplicate(true);
        }}
      >
        <Layers className="h-4 w-4" aria-hidden="true" />
        {dashboardT('campaigns.deepDuplicate')}
      </DashboardTableRowActionItem>
    </DashboardTableRowActions>
  );
}
